export class Storage {
  constructor() {
    this.storage = window.localStorage || InMemoryStorage();
  }

  getItem(key) {
    return this.storage.getItem(key);
  }

  setItem(key, value) {
    this.storage.setItem(key, value);
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }
}

export class SessionStorage {
  constructor() {
    this.storage = window.sessionStorage || InMemoryStorage();
  }

  getItem(key) {
    return this.storage.getItem(key);
  }

  setItem(key, value) {
    this.storage.setItem(key, value);
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }
}

const InMemoryStorage = () => {
  return {
    data: {},
    setItem: (key, val) => {
      if (this.data === undefined) this.data = {};
      this.data[key] = val;
    },
    getItem: (key) => {
      if (this.data === undefined) this.data = {};
      return this.data[key];
    },
    removeItem: (key) => {
      if (this.data === undefined) this.data = {};
      this.data[key] = null;
    },
    clear: () => {
      this.data = {};
    },
  };
};
